export default __webpack_public_path__ + "static/media/logo_kemna.0ae7e3f4.svg";